import designTokens from '@customink/design-tokens/build/ci_light/js/designTokens';
var themeOptions = function (theme) { return ({
    components: {
        MuiCard: {
            defaultProps: {
                variant: 'outlined',
            },
            styleOverrides: {
                root: {
                    padding: 0,
                    position: 'relative',
                    borderRadius: '8px',
                    border: "1px solid ".concat(designTokens.color.gray.accent.value),
                    transition: 'box-shadow 0.15s ease-out',
                    '&:hover': {
                        boxShadow: designTokens.shadow.medium.value,
                        border: "1px solid ".concat(designTokens.color.gray.disabled.value), // just a darker grey: #c6c6c6
                    },
                },
            },
        },
        MuiCardHeader: {
            styleOverrides: {
                root: {
                    padding: 0,
                },
                action: {
                    margin: 0,
                    display: 'flex',
                    gap: '8px',
                    alignItems: 'center',
                },
            },
        },
        MuiCardContent: {
            styleOverrides: {
                root: {
                    padding: 0,
                    marginTop: '8px',
                    color: designTokens.color.gray.obsidian.value,
                    fontFamily: theme.typography.fontFamily,
                    fontSize: designTokens.typography.body.long1.size.value,
                    lineHeight: designTokens.typography.body.long1.lineHeight.value,
                },
            },
        },
        MuiCardActions: {
            styleOverrides: {
                root: {
                    padding: 0,
                    flexDirection: 'column',
                    '> :not(:first-of-type)': {
                        margin: 'unset',
                    },
                    gap: '8px',
                },
            },
        },
    },
}); };
export default themeOptions;
//# sourceMappingURL=cardTheme.js.map